import styled, { css } from 'styled-components';

const TOTAL_SPACE = 20;
const SIZES = [8, 8, 8];

const getSize = () => (props) => {
  const size = SIZES[props.distance] || 0;
  const margin = size !== 0 ? (TOTAL_SPACE - size) / 2 : 0;

  return css`
    width: ${size}px;
    height: ${size}px;
    margin: 0 ${margin}px;
  `;
};

export const Dots = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  left: 0;
  width: 100%;
  bottom: 0;
  padding: 0 0 10px;
`;

export const Dot = styled.div`
  ${getSize()}
  background: ${(props) => (props.active ? props.activeDotColor : props.dotColor)};
  border-radius: 50%;
  transition:
    width 300ms ease-in-out,
    height 300ms ease-in-out,
    margin 300ms ease-in-out;
  cursor: pointer;
  opacity: ${(props) => (props.zooming ? 0 : 1)};
`;
